export const environment = {
  production: false,
  // Staging API is on a separate domain from the Cloudflare Pages frontend.
  // Absolute URL required — no dev-server proxy in production-like staging.
  apiUrl: 'https://staging-api.sellersage.in',
  // All seller API calls go through api-gateway (adds auth headers)
  sellerApiUrl: 'https://staging-api.sellersage.in/api/seller',
  // WebSocket through api-gateway (matches production wss://api.sellersage.in)
  wsUrl: 'wss://staging-api.sellersage.in',
};
